import { useMutation, useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { Badge, Button } from '@skupreme/shared/ui';
import { fetchMe, logout } from '../api/auth';
import { IS_STAGING } from '../env';

export function Header() {
  const me = useQuery({ queryKey: ['staff', 'me'], queryFn: fetchMe });
  const signOut = useMutation({ mutationFn: logout });

  return (
    <header className="sk:flex sk:items-center sk:gap-3 sk:border-b sk:border-b-solid sk:px-6 sk:py-3">
      <Link to="/" className="sk:font-semibold sk:text-fg">
        Skupreme Staff
      </Link>
      <Badge tone={IS_STAGING ? 'warning' : 'danger'}>
        {IS_STAGING ? 'STAGING' : 'PRODUCTION'}
      </Badge>
      <div className="sk:ml-auto sk:flex sk:items-center sk:gap-3 sk:text-dense">
        {me.isError && (
          <span className="sk:text-danger">Could not load your profile</span>
        )}
        {me.data && (
          <>
            <span>{me.data.email}</span>
            {me.data.roles.map(role => (
              <Badge key={role} tone="info">
                {role}
              </Badge>
            ))}
          </>
        )}
        <Button size="sm" onPress={() => signOut.mutate()}>
          Log out
        </Button>
      </div>
    </header>
  );
}
